export const FlightDeparturesColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Откуда',
        key: 'fromCity',
    },
    {
        name: 'Куда',
        key: 'toCity',
    },
    {
        name: 'Номер рейса',
        key: 'number',
    },
    {
        name: 'Дата вылета',
        key: 'departureAt',
    },
    {
        name: 'Дата прилета',
        key: 'arrivalAt',
    },
    {
        name: 'Статус',
        key: 'statusDescription',
    },
]
